/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';

const CinetPay = ({ Amount, attributes }) => {

    const { BaseUrl, setPaymentLod } = useContext(MyContext);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        initPayment();
    }, []);

    const initPayment = async () => {
        const localData = localStorage.getItem('LoginData');
        if (!localData) {
            setError('Utilisateur non connecté.');
            setLoading(false);
            return;
        }

        const user = JSON.parse(localData);
        const merchantTransactionId = `TXN${Date.now()}${Math.floor(Math.random() * 9999)}`;
        const nameParts = (user.name || 'Client Client').trim().split(' ');
        const firstName = nameParts[0] || 'Client';
        const lastName  = nameParts.slice(1).join(' ') || 'Client';

        const success_url = `${window.location.origin}/PaymentRespons?status_code=200&transaction_id=${merchantTransactionId}`;
        const failed_url  = `${window.location.origin}/PaymentRespons?status_code=failed`;

        // Sauvegarder l'ID de transaction avant la redirection
        sessionStorage.setItem('cinetpay_txn_id', merchantTransactionId);
        sessionStorage.setItem('payment_gateway', 'cinetpay');
        sessionStorage.setItem('Amount', Amount);

        try {
            const res = await axios.post(`${BaseUrl}cinetpay/cinetpay_init.php`, {
                amount:                  Amount,
                uid:                     localStorage.getItem('Userid') || '',
                client_email:            user.email       || '',
                client_first_name:       firstName,
                client_last_name:        lastName,
                client_phone_number:     user.mobile      || '',
                merchant_transaction_id: merchantTransactionId,
                success_url,
                failed_url,
            });

            if (res.data?.Result === 'true' && res.data?.payment_url) {
                setPaymentLod(false);
                window.location.href = res.data.payment_url;
            } else {
                const detail = res.data?.detail;
                const detailStr = detail
                    ? (detail.description || detail.message || detail.error || JSON.stringify(detail))
                    : '';
                const msg = res.data?.ResponseMsg || 'Erreur initialisation paiement';
                setError(detailStr ? `${msg} — ${detailStr}` : msg);
                setLoading(false);
                setPaymentLod(false);
            }
        } catch (err) {
            console.error('CinetPay init error:', err);
            const status = err?.response?.status;
            const detail = err?.response?.data?.ResponseMsg || err?.message || '';
            if (status === 404) {
                setError(`Endpoint introuvable (404) : ${BaseUrl}cinetpay/cinetpay_init.php`);
            } else if (status) {
                setError(`Erreur serveur (${status}) : ${detail}`);
            } else {
                setError(`Erreur réseau : ${detail || 'vérifiez que cinetpay_init.php est uploadé sur le serveur.'}`);
            }
            setLoading(false);
            setPaymentLod(false);
        }
    };

    if (error) {
        return (
            <div className="h-[100%] flex justify-center items-center">
                <p className="text-red-500 text-center px-4">{error}</p>
            </div>
        );
    }

    return (
        <div className="h-[100%] flex flex-col justify-center items-center gap-3">
            <span className="loader2"></span>
            <p className="text-gray-600 text-sm">Redirection vers CinetPay...</p>
        </div>
    );
};

export default CinetPay;
/* jshint ignore:end */
